module.exports = __webpack_public_path__ + "static/media/amex.44883ed3.svg";